





















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ResetPasswordLogBody extends Vue {
  @Prop() readonly data!: object;

  @Prop() readonly historyPage!: number;
}
